import { Box, Snackbar, Alert, AlertProps, Paper } from "@mui/material";
import SpecPanel from "../Panels/SpecPanel";
import React, { useState, useEffect } from "react";
import TabPanel from "../../../../../components/widgets/TabPanelFormat";
// import ShellTab from '../pv_data_tabs/ShellTab';
// import TableTab from "./TableTab";
// import AttachmentTab from "../pv_data_tabs/AttachmentTab";
// import McTab from "../pv_data_tabs/McTab";
import DesignTab from "./DesignTabs";
import ShellTab from "./ShellTab";
import NozzleTab from "./NozzleTab";
import PidBox from "../../../pid";
import MaterialsDBPage from "../../../MaterialsDBPage";
import { tabProps } from "../../../../../styles/muiProps";
import CustomAlert from "../../../../../components/widgets/CustomAlert";
import AttachmentTabs from "./AttachmentTabs";
import NavTabs from "../../../../../components/Tabs/NavTabs";
import Modeling2DPanel from "../Panels/ModelingPanel/Panels/Modeling2DPanel";
import { TablesTab } from "../../../AllEquipments/CommonFeatures/SidePanel/TablesTab/TablesTable";
import FIleButton from "./FIleButton";
import { useGeneralContext } from "../../../AllEquipments/CommonFeatures/SidePanel/GeneralContext";
import { ModelingControls } from "../../../AllEquipments/CommonFeatures/SidePanel/ModelingControls";
const MuiAlert = React.forwardRef(function Alert(props, ref) {
  return <Alert elevation={6} ref={ref} variant="filled" {...props} />;
});

const DataTabs = (props) => {
  document.title = "Pressure Vessel - Data";
  const [currentTab, setCurrentTab] = React.useState(0); //value of the current tab
  const [open, setOpen] = React.useState(false); //for alert open
  const [key, setKey] = React.useState(Math.random());
  const [pidState, setPidState] = useState(0);
  const { projectId, project, equip } = props;

  // To Show the needed items on the toolbar
  const { setTab, selectedModelingRevision } = useGeneralContext();

  // ✅ FIX 1: Toolbar tab setup (runs once)
  useEffect(() => {
    setTab("pv");
  }, [setTab]);

  const handleChange = (newValue) => {
    console.log("Tab changed to:", newValue);
    setCurrentTab(newValue);
  };

  const reRender = () => {
    setKey(Math.random());
  };
  const PV_Tabs = [
    "Design",
    "Shell",
    "Nozzles",
    "Attachments",
    "Materials",
    "Notes",
    "Tables",
  ];
  const tabs = [
    {
      label: "Design",
      panel: <DesignTab pidState={pidState} />,
      panelKey: `design-${selectedModelingRevision}`,
      to: "design",
    },
    {
      label: "Shell",
      panel: (
        <ShellTab
          key={`${selectedModelingRevision}-${key}`}
          reRender={reRender}
          project={project}
          pidState={pidState}
          equipId={equip?.id}
        />
      ),
      panelKey: `shell-${selectedModelingRevision}`,
      to: "shell",
    },
    {
      label: "Nozzles",
      panel: (
        <NozzleTab
          key={`${selectedModelingRevision}-${key}`}
          reRender={reRender}
          pidState={pidState}
          project={project}
        />
      ),
      panelKey: `nozzles-${selectedModelingRevision}`,
      to: "nozzles",
    },
    {
      label: "Attachments",
      panelProps: { padding: 0 },
      panel: <AttachmentTabs />,
      to: "attachments",
    },
    // {
    //   label: "2D",
    //   panel: <Modeling2DPanel />,
    //   to: "2d",
    // },
    // {
    //   label: "Materials",
    //   panelProps: { padding: 0 },
    //   panel: <MaterialsDBPage project={project} equip={equip} />,
    //   to: "materials",
    // },
    // {
    //   label: "Spec",
    //   panel: <SpecPanel />,
    //   to: "spec",
    // },

    // {
    //   label: "Notes",
    //   panel: <></>,
    //   to: "notes",
    // },
    // {
    //   label: "Tables",
    //   panel: <TablesTab tab="pv" />,
    //   to: "tables",
    // },
    // {
    //   label: "Tables",
    //   panel: <TableTab />,
    //   to: "tables",
    // },
    // {
    //   label: "Change Order",
    //   panel: <></>,
    //   to: "change_order",
    // },
  ];

  return (
      <Box
        sx={{ width: "auto", display: "flex", flexDirection: "row", flex: 1 }}
      >
        <Box sx={{ width: "100%" }}>
          <Paper>
            <NavTabs
              tabs={tabs}
              navLabel="data-tab"
              handleOutputChange={handleChange}
              tabProps={tabProps}
            >
              {[0, 1, 2, 3, 4].includes(currentTab) && (
                <Box sx={{ flexGrow: 1 }}>
                  <ModelingControls />
                </Box>
              )}
            </NavTabs>
          </Paper>
        </Box>
        {/* {currentTab in [0, 1, 2] ? (
        <PidBox pidState={pidState} setPidState={setPidState} />
      ) : null} */}

      </Box>
  );
};

export default DataTabs;
